export const TEXT_TAG = {
  span: 'span',
  label: 'label',
  p: 'p',
  div: 'div',
} as const;

export const TEXT_COLOR = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  success: 'success',
  danger: 'danger',
  white: 'white',
  inactive: 'inactive',
} as const;

export const TEXT_SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  extraLarge: 'extraLarge',
} as const;

export const TEXT_ALIGN = {
  left: 'left',
  center: 'center',
  right: 'right',
} as const;

export const TEXT_WEIGHT = {
  light: 'light',
  semiBold: 'semiBold',
  bold: 'bold',
  regular: 'regular',
} as const;
